// extracted by mini-css-extract-plugin
export var alertIcon = "_tt-0";